<template>
  <div
    class="text-h3 mb-4"
    data-id="section-title"
  >
    <slot />
  </div>
</template>
